import SiteController from './SiteController';

require('../css/main.scss');

export default class App {

  constructor(options) {

    this.options = options;

    this.pageController = {};
    this.siteController = {};

  }

  start() {
    $('document').ready( e => this.handleAppReady(e) );
  }

  handleAppReady() {
    console.log('APP READY!');

    this.siteController = new SiteController(this.options);

    if ( typeof this.options.pageController !== 'undefined' && this.options.pageController !== '' ) {
      require.ensure([], (require) => {
        const PageController = require(`./pages/${this.options.pageController}`).default;
        this.pageController = new PageController(this.options);
      });
    } else {
      console.log('PAGE CONTROLLER NOT LOADED');
    }

  }

}



// WEBPACK FOOTER //
// ./js/app.js